import request, { fetchPost } from "@/utils/request";

const prefixMap = {
    1: 'https://dev.minicreate.qq.com',
    2: 'https://dev.minipre.qq.com',
    3: 'https://dev.minipre.qq.com',
    4: 'https://eadev.dream.qq.com',
    5: 'https://dev.dream.qq.com',
}

const getPrefix = (envStatus) => {
    return prefixMap[envStatus] || ''
}

// 获取用户会话
export function getUserSession(data, envStatus) {
    if (envStatus == 3) {
        data.eapre = 1
    }
    return fetchPost({
        url: getPrefix(envStatus) + "/api?c=AIChat&a=getUserSession",
        method: "post",
        data,
    });
}

// 获取会话
export function getSession(data, envStatus) {
    if (envStatus == 3) {
        data.eapre = 1
    }
    return fetchPost({
        url: getPrefix(envStatus) + "/api?c=AIChat&a=getSessionReq",
        method: "post",
        data,
    });
}

// 添加会话
export function addChat(data, envStatus) {
    if (envStatus == 3) {
        data.eapre = 1
    }
    return fetchPost({
        url: getPrefix(envStatus) + "/api?c=AIChat&a=addChat",
        method: "post",
        data,
    });
}

// 添加会话
export function scoringChat(data, envStatus) {
    if (envStatus == 3) {
        data.eapre = 1
    }
    return fetchPost({
        url: getPrefix(envStatus) + "/api?c=AIChat&a=scoringChat",
        method: "post",
        data,
    });
}// 添加会话
export function cancelAssociation(data, envStatus) {
    if (envStatus == 3) {
        data.eapre = 1
    }
    return fetchPost({
        url: getPrefix(envStatus) + "/api?c=AIChat&a=cancelAssociation",
        method: "post",
        data,
    });
}

// 删除会话
export function clearChat(data, envStatus) {
    if (envStatus == 3) {
        data.eapre = 1
    }
    return fetchPost({
        url: getPrefix(envStatus) + "/api?c=AIChat&a=clearChat",
        method: "post",
        data,
    });
}

// 编辑标题
export function modifyName(data, envStatus) {
    if (envStatus == 3) {
        data.eapre = 1
    }
    return fetchPost({
        url: getPrefix(envStatus) + "/api?c=AIChat&a=modifyName",
        method: "post",
        data,
    });
}

// 判断消息是否合法
export function isIligleText(data, envStatus) {
    if (envStatus == 3) {
        data.eapre = 1
    }
    return fetchPost({
        url: getPrefix(envStatus) + "/api?c=AIChat&a=secDetect",
        method: "post",
        data,
    });
}



